export default __webpack_public_path__ + "static/logo-6776d98a98e971fe0ab3b1bb1e1a5460.svg";